export const AdminHomePath = '/admin';
export const AdminBillingHomePath = '/admin/billing';
export const AdminBillingPricesPath = '/admin/billing/prices';
export const AdminBillingInvoiceListPath = '/admin/billing/invoices';
export const AdminBillingInvoiceDetailsPath = {
  path: '/admin/billing/invoices/:invoiceId',
  withId: (invoiceId: string): string => {
    return AdminBillingInvoiceDetailsPath.path.replace(':invoiceId', invoiceId);
  },
};
export const AdminBillingFailedTransactionsPath = '/admin/billing/failed-transactions';
export const AdminStoreListPath = '/stores';
export const AdminSettingsPath = {
  profile: '/settings/profile',
  currency: '/settings/currency',
  language: '/settings/language',
};
export const RetailerListPath = '/retailers';
export const RetailerAddPath = '/retailers/add';
export const RetailerEditPath = {
  path: '/retailers/:retailerId',
  withId: (id: string): string => {
    return RetailerEditPath.path.replace(':retailerId', id);
  },
};
export const RetailerStoreListPath = {
  path: '/retailers/:retailerId/stores',
  withRetailerId: (retailerId: string): string => {
    return RetailerStoreListPath.path.replace(':retailerId', retailerId);
  },
};
export const RetailerStoreAddPath = {
  path: '/retailers/:retailerId/stores/add',
  withRetailerId: (retailerId: string): string => {
    return RetailerStoreAddPath.path.replace(':retailerId', retailerId);
  },
};
export const RetailerStoreEditPath = {
  path: '/retailers/:retailerId/stores/:storeId',
  withParams: (retailerId: string, storeId: string): string => {
    return RetailerStoreEditPath.path
      .replace(':retailerId', retailerId)
      .replace(':storeId', storeId);
  },
};
export const RetailerStoreEditAddressPath = {
  path: '/retailers/:retailerId/stores/:storeId/:address',
  withParams: (retailerId: string, storeId: string, address: string): string => {
    return RetailerStoreEditAddressPath.path
      .replace(':retailerId', retailerId)
      .replace(':storeId', storeId)
      .replace(':address', address);
  },
};
export const OrganizationAddPath = '/organizations/add';
export const OrganizationEditPath = {
  path: '/organizations/:organizationId',
  withId: (id: string): string => {
    return OrganizationEditPath.path.replace(':organizationId', id);
  },
};
export const OrganizationListPath = '/organizations';
export const SupplierAddPath = '/suppliers/add';
export const SupplierEditPath = {
  path: '/suppliers/:supplierId',
  withId: (id: string): string => {
    return SupplierEditPath.path.replace(':supplierId', id);
  },
};
export const SupplierEditSectionPath = {
  path: '/suppliers/:supplierId/:section',
  withParams: (supplierId: string, section: string): string => {
    return SupplierEditSectionPath.path
      .replace(':supplierId', supplierId)
      .replace(':section', section);
  },
};
export const SupplierListPath = '/suppliers';
export const StoreEditPath = {
  path: '/stores/:storeId',
  withId: (id: string): string => {
    return StoreEditPath.path.replace(':storeId', id);
  },
};
export const StoreEditAddressPath = {
  path: '/stores/:storeId/:address',
  withParams: (storeId: string, address: string): string => {
    return StoreEditAddressPath.path.replace(':storeId', storeId).replace(':address', address);
  },
};
export const UserAddPath = '/users/add';
export const UserEditPath = {
  path: '/users/:userId',
  withId: (id: string): string => {
    return UserEditPath.path.replace(':userId', id);
  },
};
export const UserListPath = '/users';
export const SupplierToRetailerListPath = {
  path: '/suppliers/:supplierId/retailers',
  withSupplierId: (supplierId: string) => {
    return SupplierToRetailerListPath.path.replace(':supplierId', supplierId);
  },
};
export const SupplierToRetailerAddPath = {
  path: '/suppliers/:supplierId/retailers/add',
  withSupplierId: (supplierId: string) => {
    return SupplierToRetailerAddPath.path.replace(':supplierId', supplierId);
  },
};
export const SupplierToRetailerEditPath = {
  path: '/suppliers/:supplierId/retailers/:retailerId',
  withParams: (supplierId: string, retailerId: string) => {
    return SupplierToRetailerEditPath.path
      .replace(':supplierId', supplierId)
      .replace(':retailerId', retailerId);
  },
};
export const SupplierToStoreListPath = {
  path: '/suppliers/:supplierId/stores',
  withSupplierId: (supplierId: string) => {
    return SupplierToStoreListPath.path.replace(':supplierId', supplierId);
  },
};
export const SupplierToStoreAddPath = {
  path: '/suppliers/:supplierId/stores/add',
  withSupplierId: (supplierId: string) => {
    return SupplierToStoreAddPath.path.replace(':supplierId', supplierId);
  },
};
export const SupplierToStoreEditPath = {
  path: '/suppliers/:supplierId/stores/:storeId',
  withParams: (supplierId: string, storeId: string) => {
    return SupplierToStoreEditPath.path
      .replace(':supplierId', supplierId)
      .replace(':storeId', storeId);
  },
};
